<app-exit-banner></app-exit-banner>
<div class="main-container">
	<router-outlet></router-outlet>
</div>
